import axios from 'axios';
import { FilemakerCreateContactTestInfo } from '@resources/scripts/models/filemakerSubmissions/FilemakerCreateContactTestInfo.model';

export const getTestOrganizationById = async (organizationId: string) => axios.get(`/api/test-organization/${organizationId}`);
export const createTestContact = async (submission: FilemakerCreateContactTestInfo) => axios.post('/api/test-organization', submission);
export const updateTestContact = async (organizationId: string, submission) => axios.patch(`/api/test-organization/${organizationId}`, submission);
export const getTestResultsByOrganizationId = async (organizationId: string) => axios.get(`/api/test-organization/${organizationId}`);
export const createTestContactResults = async (organizationId: string, submission) => axios.post('/api/test-organization/test-results', submission);

export default {
  getTestOrganizationById,
  createTestContact,
  updateTestContact,
  getTestResultsByOrganizationId,
  createTestContactResults,
};